<script>
export default {
  data() {
    return {
      showCartEmpty: false,
    };
  },
  created() {
    this.$on('switchTab', this.test);
  },
  methods: {
    test() {
      $('#tab-1').click();
    },
    moveToList() {
      return this.$notify({
        type: 'success',
        message: 'Item (fake) moved to list!',
      });
    },
    moveAllToList() {
      return this.$notify({
        type: 'success',
        message: 'All Items (fake) moved to list!',
      });
    },
  },
};
</script>
